const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "c031acea785cd058803c35266dacdaaf4af4ed8d-Ubuntu7Standard:fd1ec39a-3056-4c17-a3d0-d1389c2baf47",
};

export default sentryConfig;
